import React, { ReactElement, useCallback, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from 'src/components/store';
import { ComponentNamesForPermission, LevelName } from 'src/utils/enums';
import { levelNameToValue, permissionsConfig } from './config-permissions';
import { UpgradeButton } from './upgrade-button/upgrade-button';

interface PermissionsProps {
    componentName: ComponentNamesForPermission | undefined;
    children: (hasPermissions: boolean, UpgradeButton?: () => JSX.Element) => ReactElement<{ hasPermissions: boolean, icon: () => JSX.Element }>;
}

export const ProtectPermissions: React.FC<PermissionsProps> = observer(({ componentName, children }) => {
    const { customerStore } = useStores();

   const allowedServiceLevel = useMemo(() => componentName ? permissionsConfig[componentName] : undefined, [componentName]);

    const hasAppropriateLevel = useCallback((levelName: LevelName | undefined) => {
        if (levelName === undefined) return true;
        const serviceLevel = customerStore.selectedLocation?.serviceLevel;
        return serviceLevel && levelNameToValue[serviceLevel] >= levelNameToValue[levelName];
    }, [customerStore.selectedLocation]);

    return hasAppropriateLevel(allowedServiceLevel) ?
        children(true) :
        children(false, () => <UpgradeButton />);
});

